import { ExportFormat } from '@/core/export/types'
import { JPEG_ENCODER, PNG_ENCODER } from '@/core/render/encoders/canvasEncoder'
import type { ImageEncoder } from '@/core/render/encoders/types'

const ENCODERS: Readonly<Record<ExportFormat, ImageEncoder>> = {
  [ExportFormat.Jpeg]: JPEG_ENCODER,
  [ExportFormat.Png]: PNG_ENCODER,
}

export function getEncoder(format: ExportFormat): ImageEncoder {
  const encoder = ENCODERS[format]
  if (!encoder) {
    throw new Error(`No image encoder configured for format "${String(format)}"`)
  }
  return encoder
}

export * from '@/core/render/encoders/types'
export * from '@/core/render/encoders/canvasEncoder'
export * from '@/core/render/encoders/metadata'
